import { gql } from "@apollo/client";

export const GET_METER_DELIVERY_REQUESTS = gql`
  query GetMeterDeliveryRequests(
    $page: Int, 
    $pageSize: Int, 
    $search: String, 
    $searchFields: [String!], 
    $sort: String, 
    $status: MeterDeliveryServiceRequestStatus
  ) {
    rows: getMeterDeliveryServiceRequests(
      page: $page, 
      pageSize: $pageSize, 
      search: $search, 
      searchFields: $searchFields, 
      sort: $sort, 
      status: $status
    ) {
      _id
      code
      createdAt
      createdBy {
        firstName
        lastName
        phoneNumber
      }
      request {
        proposedStartDate
        estimatedProductionCompletionDate
        testSets {
          meterPhase
          content {
            meterNumber
          }
        }
        testAtOwnFacility
        singlePhaseMeterEnclosures
        threePhaseMeterEnclosures
      }
      meterContractorCode
      meterContractor {
        name
        code
      }
      status
    }
    count: getMeterDeliveryServiceRequestsCount(
      search: $search,
      searchFields: $searchFields,
      status: $status
    )  
  }
`;


export const CREATE_METER_DELIVERY_REQUEST = gql`
  mutation CreateMeterDeliveryServiceRequest(
    $request: MeterDeliveryServiceRequestInput
  ) {
    createMeterDeliveryServiceRequest(request: $request) {
      _id
    }
  }
`;

export const GET_METER_CONTRACTOR = gql`
  query GetMeterContractor(
    $id: ID!
  ) {
    meterContractor: getMeterContractor(
      id: $id
    ) {
      _id
      testingFacility {
        name 
        address
      }
      documentation {
        approvedTechnicalDocument {
          url
          uploadedAt
        }
        calibrationCertificate {
          url
          uploadedAt
        }
        typeTestReport {
          url
          uploadedAt
        }
        ISO14001 {
          url
          uploadedAt
        }
        ISO45001 {
          url
          uploadedAt
        }
        ISO9001 {
          url
          uploadedAt
        }
        schematicWiringDrawing {
          url
          uploadedAt
        }
        installationOperationalAndMaintenanceManuals {
          url
          uploadedAt
        }
        detailedPartListAndMaterialsOfConstruction {
          url
          uploadedAt
        }
      }
    }
  }
`;




